module.exports = __webpack_public_path__ + "img/m_shaped.d37b55fc.jpg";